module.exports = __webpack_public_path__ + "static/media/ar.fab5d7bc.svg";